import { useInquiryModal } from '@/components/utilities/InquiryModalContext';

const CheckIcon = () => (
  <svg className="mt-px shrink-0" width={18} height={18} viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <circle cx="9" cy="9" r="9" fill="#E6F9F1" />
    <path
      d="M5 9.5L7.5 12L13 6.5"
      stroke="#07c276"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function ServicesCardsBlock({
  eyebrow,
  servicesCardsTitle: title,
  servicesCardsDescription: description,
  servicesCards: cards = []
}) {
  const { open } = useInquiryModal();

  return (
    <section className="bg-white py-[72px] max-md:py-12">
      <div className="mx-auto w-full max-w-[1224px] px-6">
        {(eyebrow || title || description) && (
          <div className="mb-12 text-center">
            {eyebrow && (
              <span className="mb-4 inline-block text-sm font-semibold tracking-[0.08em] text-brand-500 uppercase">
                {eyebrow}
              </span>
            )}
            {title && <h2 className="mb-3 text-[36px] leading-[1.2] text-[#1D1816]">{title}</h2>}
            {description && (
              <p className="mx-auto max-w-[480px] text-base text-[#6D6D6D]">{description}</p>
            )}
          </div>
        )}

        <div className="grid grid-cols-1 gap-6 [@media(min-width:900px)]:grid-cols-3">
          {cards.map((card) => (
            <article
              key={card.id}
              className="flex flex-col rounded-2xl bg-white px-8 pt-9 pb-8 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.15)] transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-0.5 hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.22)]"
            >
              <h3 className="font-sans mb-3 text-base font-semibold tracking-[0.08em] text-[#1D1816] uppercase leading-[1.3]">
                {card.title}
              </h3>
              {card.description && (
                <p className="mb-6 text-base leading-[1.65] text-[#6D6D6D]">{card.description}</p>
              )}
              <ul className="mb-7 flex flex-1 flex-col gap-2.5">
                {(card.features || []).map((feature) => (
                  <li
                    key={feature.id}
                    className="flex items-start gap-2.5 text-base leading-[1.5] text-[#1D1816]"
                  >
                    <CheckIcon />
                    <span>{feature.text}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-6">
                {card.priceLabel && (
                  <span className="inline-flex items-center rounded-full bg-[#E6F9F1] px-5 py-2.5 text-sm font-semibold whitespace-nowrap text-[#056044]">
                    {card.priceLabel}
                  </span>
                )}
                {card.ctaLabel && (
                  <button
                    type="button"
                    onClick={() => open(card.serviceId)}
                    className="inline-flex cursor-pointer items-center rounded-full bg-brand-400 px-5 py-2.5 text-sm font-normal text-white transition-colors hover:bg-brand-500"
                  >
                    {card.ctaLabel}
                  </button>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
